// OpenAI (ChatGPT Ads) click identifier for Conversions API attribution.
// The OpenAI pixel stores the click id in a first-party __oppref cookie on
// the landing page; we attach it as traits.oppref (mirroring how _fbp flows
// as facebook_browser_id) so the RudderStack transformation can forward it
// and server-side conversions can be credited to the ad click.

import { getCookie } from "@/util/cookie";

const getParam = (name: string): string => {
  if (typeof window === "undefined") return "";
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) || "";
  } catch {
    return "";
  }
};

export const getOpprefTrait = (): Record<string, string> => {
  const oppref = getCookie("__oppref") || getParam("oppref");
  return oppref ? { oppref } : {};
};
